module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Steve Duno\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('I', [_vm._v("Last Dog on the Hill ")]), _vm._v("is veteran pet behaviorist STEVE DUNO's eighteenth book. He has trained thousands of dogs, and a good number of cats. He lives in Seattle with his family and an ever-changing assortment of rescued pets.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/l4eXw2/tc-custom/9781429950459.jpg?1726518954590",
      "alt": "This image is the cover for the book Last Dog on the Hill"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Last Dog on the Hill\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("The moving story of the author's adopted Rottweiler mix, Lou, a free-thinking heroic dog who changed his life forever "), _c('br'), _c('br')])]), _vm._v("Born of guard dogs on a secret marijuana farm in Mendicino County, Lou truly was one dog in a million. On the winter day that the ailing, tick-infested feral pup was rescued by Steve Duno, neither dog nor man had a clue as to what they were getting into, or where the relationship would lead. "), _c('br'), _c('br'), _c('i', [_vm._v("Last Dog on the Hill ")]), _vm._v("tells the story of an indigent young Rottweiler mix who, after abandoning his pack and the hills of his birth, went on to change the lives of hundreds of people and dogs, including the author's, whose career as a behaviorist and writer was made possible through Lou's extraordinary intelligence and heart. Lou won the respect of gang members, foiled an armed robbery, caught a rapist, fought coyotes and kidnappers, comforted elderly war veterans and Alzheimer patients in their final days, taught ASL to kids, learned scores of unique behaviors and tricks, amassed a vocabulary of nearly 200 words, helped rehabilitate hundreds of aggressive dogs and saved them from euthanasia. He was also a clown, consummate performer and Steve's best friend for sixteen years. His story will make readers laugh and cry in equal measures.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0